// extracted by mini-css-extract-plugin
module.exports = {"bold":"af9_wy"};